const apiUrl = external => {
  const whichApi = external ? 'external' : 'admin'
  const path = `/static/swagger/${whichApi}/swagger.yaml`
  let endpoint = __ENDPOINT__
  if (!endpoint) {
    const isEu = __STAGINGEU__ || __PRODEU__
    const region = isEu ? 'eu' : 'us'
    const useStaging = __LOCAL__ || __DEV__ || __STAGING__ || __STAGINGEU__
    const environment = useStaging ? 'staging' : 'production'
    endpoint = `https://${region}-kardia-${environment}.alivecor.com`
  }
  return `${endpoint}${path}`
}

export default apiUrl



// WEBPACK FOOTER //
// ./src/components/Swagger/apiUrl.js